export default "__VITE_ASSET__BYLsseVa__"